// extracted by mini-css-extract-plugin
export default {"textAreaInputContainer":"PIl7jidd","labelRow":"WLaoSFEo","label":"ZdLmTtO5","input":"gm2eMe7f"};